export default "__VITE_ASSET__D$J_AAEJ__"